module.exports = __webpack_public_path__ + "img/emptyvirtualaccount.e606503d.png";